export enum LocaleCodeEnum {
  Polish = 'pl_PL'
}
